import { useResearchQuota } from "../context/QuotaContext";
import { glassStyle } from "../styles";

const QuotaNotice = () => {
  const { quota } = useResearchQuota();

  if (!quota || !quota.blocked_by) return null;

  const isDaily = quota.blocked_by === "daily";
  const window = quota[quota.blocked_by];
  const resetLabel = new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(window.resets_at));

  const title = isDaily
    ? "Cota diária de pesquisas atingida"
    : "Cota mensal de pesquisas atingida";
  const hint = isDaily
    ? `Você atingiu o limite de ${window.limit} pesquisas hoje. Nova cota disponível em ${resetLabel} (${quota.time_zone}).`
    : `Você atingiu o limite de ${window.limit} pesquisas neste mês. Nova cota disponível em ${resetLabel} (${quota.time_zone}).`;

  return (
    <div className={`${glassStyle.card} border-[#FE363B]/30 bg-[#FE363B]/5 font-['DM_Sans']`}>
      <p className="text-sm font-semibold text-gray-900">{title}</p>
      <p className="text-sm text-gray-600 mt-1">{hint}</p>
    </div>
  );
};

export default QuotaNotice;
